import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router";
import { getConfig, getTemplates } from "../ApiCalls";
import Loader from "../common/Loader";
import BookList from "./BookList";
import { chooseLang } from "../common/chooseLang";

const WrapperStyled = styled.div`
    max-width: 1200px;
    margin: auto;
    min-height: 670px;
    height: 700px;
    overflow: auto;

    @media (max-width: 1200px) {
        width: 100%;
        max-width: 100%;
    }
    
    @media (max-width: 600px) {
        height: 460px;
        min-height: 460px;
    }
`;

const LoaderStyled = styled.div`
    text-align: center;
    margin-top: 20px;
`;

const LibraryV2 = () => {
    const location = useLocation();
    const queryParameters = new URLSearchParams(location.search);
    const lang = queryParameters.get("language") || "he";
    const clientId = queryParameters.get("clientId") || "64d491633684ef0d32edb473";
    const templateId = queryParameters.get("templateId");

    const [loading, setLoading] = useState(true);
    const [templates, s_templates] = useState([]);
    const [config, s_config] = useState(null);

    const langData = chooseLang(lang);

    useEffect(() => {
        if (clientId) {
            getConfig(lang, clientId).then(data => {
                s_config(data);
            }).catch(e => {
                console.log("e", e);
            });
        }
    }, []);

    useEffect(() => {
        getTemplates(lang, clientId, templateId)
            .then(data => {
                s_templates(data);
                setLoading(false);
            })
            .catch(e => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        if (lang === "he" || lang === "ar") {
            document.dir = "rtl";
            document.title = langData?.general?.pageTitle;
        } else {
            document.dir = "ltr";
            document.title = langData?.general?.pageTitle;
        }
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <WrapperStyled className={ `container lang-${ lang }` }>
            { loading && (
                <LoaderStyled>
                    <Loader/>
                </LoaderStyled>
            ) }
            { !loading && (
                <BookList
                    lang={ lang }
                    langData={ langData }
                    list={ templates }
                    config={config}
                />
            ) }
        </WrapperStyled>
    );
};

export default LibraryV2;
